import { ConfigurationKey } from "@intelligems/ig-types/dtos/configurations";
import type { RootState } from "@src/store/rootState";
import { getOrganization } from "@src/store/slices/organization";

export const getConfiguration =
  <T>(key: Lowercase<ConfigurationKey>) =>
  (state: RootState) => {
    const organization = getOrganization(state);
    const config = organization?.configurations?.find((c) => key === c.key);
    return (config?.value as T) ?? undefined;
  };
